module.exports = __webpack_public_path__ + "static/media/skybox-1.e19c7a0e.hdr";